(ns minorodata.connections.sources.quickbooks
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]
            [mold-forms.core :as form-component]))


(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description
  (spec/nilable string?))


(spec/def ::auth-credentials-id
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Please provide a valid auth token"})))


(spec/def ::auth-credentials
  (spec/keys :req-un [::auth-credentials-id]))


(spec/def ::quickbooks-form
  (spec/keys :req-un [::name ::auth-credentials]
             :opt-un [::description]))


(def source
  {:id                "quickbooks-oauth"
   :enabled           false
   :name              "Quickbooks oAuth"
   :description       "Plan, save, and bank—all in one place"
   :image-source      "quickbooks.svg"
   :tags              ["admin-finance"]

   :preview-formatter (fn [source]
                        (if (:is-token-valid source)
                          (str "Authenticated by token")
                          [:span {:class "text-kleene-error-01"
                                  :title         "TOKEN EXPIRED"}
                           "AUTH TOKEN EXPIRED"]))

   :form              {:format-for-api
                       (fn format-for-api [{:keys [auth-credentials name description]}]
                         {:source-type "quickbooks-oauth"
                          :name        name
                          :description description
                          :source      {:auth-credentials-id (:auth-credentials-id auth-credentials)
                                        :is-token-valid      (:is-token-valid auth-credentials)
                                        :has-third-leg       true
                                        :realm-id            (:realm-id auth-credentials)}})

                       :format-for-inputs
                       (fn format-for-inputs [{:keys [source name description]}]
                         (let [{:keys [auth-credentials-id is-token-valid realm-id]} source]
                           {:name                name
                            :description         description
                            :auth-credentials    (when (and (some? auth-credentials-id)
                                                            (some? is-token-valid))
                                                   {:auth-credentials-id auth-credentials-id
                                                    :is-token-valid      is-token-valid
                                                    :realm-id            realm-id})
                            :auth-credentials-id auth-credentials-id
                            :is-token-valid      is-token-valid
                            :realm-id            realm-id}))

                       ;; TODO:
                       ;; Replace :format-for-api and :format-for-fields with a single :mapping, like so
                       ;; {:block-type :input
                       ;;  :name       :some-name
                       ;;  :mapping    [:credentials :some_name]}
                       ;; Also, think of having `:input-type :hidden` blocks as placeholders
                       ;; for static fields in the final configuration.

                       :validate
                       (partial form-component/validate-form ::quickbooks-form)

                       :id
                       :quickbooks-oauth-form

                       :blocks
                       [{:block-type :input
                         :label      "Source name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type           :oauth
                         :label                "Quickbooks Login"
                         :name                 :auth-credentials
                         :required             true

                         :request-uri          "https://appcenter.intuit.com/connect/oauth2"
                         :params-processor     (fn [{:keys [client-id redirect-uri state scope response-type]}]
                                                 {:response_type response-type
                                                  :scope         scope
                                                  :client_id     client-id
                                                  :redirect_uri  redirect-uri
                                                  :state         state})

                         :response-processor   (fn [data oauth-redirect-params]
                                                 (assoc (select-keys data [:auth-credentials-id :is-token-valid])
                                                        :realm-id (:realmId oauth-redirect-params)))

                         :oauth-connector-type "quickbooks"
                         :has-third-leg        true

                         :response-type        "code"
                         :client-id            "ABcP3KZmuvnjCxejr3vq2nBCeNwK2JWKp7wq17QxAfrdWjIUPA"
                         :scope                "com.intuit.quickbooks.accounting"}

                        {:block-type :submit
                         :content    "SAVE"}]}

   :extract-form      {:format-for-api
                       (fn format-for-api [{:keys [name description status
                                                   action destination-table report
                                                   extract-type query column endpoint endpoint-query]}]
                         {:name          name
                          :description   description
                          :status        status
                          :output-tables [destination-table]
                          :config        {:extracts [{:action            action
                                                      :report            report
                                                      :destination-table destination-table
                                                      :extract-type      extract-type
                                                      :query             query
                                                      :column            column
                                                      :endpoint          endpoint
                                                      :endpoint-query    endpoint-query}]}})

                       :format-for-inputs
                       (fn format-for-inputs [{:extract/keys [name description status config source-id]}]
                         (let [extract (get-in config [:extracts 0])]
                           (merge
                            (select-keys extract [:report :action :destination-table :extract-type :realm-id
                                                  :query :column :endpoint :endpoint-query])
                            (app.utils/keep-non-nil-keys
                             {:name          name
                              :description   description
                              :status        status
                              :output-tables []

                              :source-id     source-id}))))

                       :validate
                       (constantly nil)

                       :id
                       :quickbooks-oauth-extract-form

                       :blocks
                       [{:block-type :input
                         :label      "Extract name"
                         :required   true
                         :name       :name
                         :value      ""}

                        {:block-type :input
                         :label      "Description"
                         :name       :description
                         :value      ""}

                        {:block-type :select
                         :label      "Status"
                         :name       :status
                         :options    [{:name "Active" :value "active"}
                                      {:name "Paused" :value "paused"}]
                         :required   true
                         :value      "active"}

                        {:block-type :subtitle
                         :content    "Extract Configuration"}

                        {:block-type :form-value
                         :name       :source-id}

                        {:block-type :select
                         :label      "Report"
                         :name       :report
                         :options    [{:name "Query"  :value "query"}
                                      {:name "Report" :value "report"}]
                         :disabled   false
                         :required   true
                         :value      "query"}

                        {:content "Don't add STARTPOSITION and/or MAXRESULTS on your query as it's managed by the app"
                         :conditions [[:eq [:report :value] "query"]]}

                        {:block-type :input
                         :label      "Query String"
                         :name       :query
                         :value      ""
                         :placeholder "Select * from Account"
                         :conditions [[:eq [:report :value] "query"]]}

                        {:block-type :input
                         :label      "From Table (capitalized)"
                         :name       :column
                         :value      ""
                         :placeholder "Account"
                         :conditions [[:eq [:report :value] "query"]]}

                        {:block-type :input
                         :label      "Report Endpoint"
                         :name       :endpoint
                         :value      ""
                         :placeholder "AccountList"
                         :conditions [[:eq [:report :value] "report"]]}

                        {:block-type :input
                         :label      "Query string"
                         :name       :endpoint-query
                         :value      ""
                         :placeholder "columns=account_name,account_type&account_type=Income"
                         :conditions [[:eq [:report :value] "report"]]}

                        {:block-type :select
                         :label      "Load method"
                         :name       :action
                         :options    [{:name "Drop, Create, Load" :value "replace"}
                                      {:name "Truncate, Load"     :value "reload"}
                                      {:name "Append"             :value "append"}]
                         :required   true
                         :value      "replace"}

                        {:content "Drop table, Create table, load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "replace"]]}

                        {:content "Truncate table, Load entire table (selected columns)"
                         :conditions [[:eq [:action :value] "reload"]]}

                        {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
                         :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "full-load"]]]}

                        {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
                         :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

                        {:block-type :subtitle
                         :content    "Destination table"}

                        {:block-type  :warehouse-destination
                         :name        :destination-table}

                        {:block-type :submit
                         :content    "SAVE"}]}})
